<template>
    <div>
        <h2 v-if="obData.catalogSectionList && obData.catalogSectionList.messages" class="def-header-2 container">
            {{obData.catalogSectionList.messages.title}}
        </h2>
        <!--filter-->
        <form action="javascript: void(0)" ref="pageBlogFilter">
            <PerfectScrollbar>
                <input type="hidden" v-for="item in obData.catalogSmartFilter.hidden" :name="item.name" :value="item.value">
                <div v-for="(item, i) in obData.catalogSmartFilter.ITEMS" :key="i" class="page-blog-filter">
                    <label class="page-blog-filter__item"
                           :class="{'page-blog-filter__item_atcive' : element.CHECKED}"
                           v-for="(element, k) in item.VALUES" :key="k">
                        <input
                            type="checkbox"
                            :name="element.CONTROL_NAME"
                            value="Y"
                            @change="changeFilter()"
                            :checked="element.CHECKED"
                        >
                        <span>#{{element.VALUE}}</span>
                    </label>
                </div>
            </PerfectScrollbar>
        </form>
        <div class="container">
            <div class="page-blog__items">
                <jewelry-card v-for="item in obData.catalogSectionList.items" :key="item.id" :result="item"/>
            </div>
            <Pagination
                :result="obData.catalogSectionList.pagination"
                @change="getPage"
                @addMore="addMore"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'page-blog',
        selector: '.page-blog',
        props: {
            result: {
                type: Object,
                default: () => ({"catalogSmartFilter":{"form":{"name":null,"action":"/blog/filter/clear/apply/","method":"get"},"hidden":[{"name":"ajax","value":"y"}],"ITEMS":{"248":{"ID":"248","IBLOCK_ID":"26","CODE":"TAGS","~NAME":"Теги","NAME":"Теги","PROPERTY_TYPE":"S","USER_TYPE":"directory","USER_TYPE_SETTINGS":{"size":1,"width":0,"group":"N","multiple":"N","TABLE_NAME":"ly_tags"},"DISPLAY_TYPE":"F","DISPLAY_EXPANDED":"Y","FILTER_HINT":"","VALUES":{"1f17d3cb7c9dfdcc9f60997d5437264a":{"CONTROL_ID":"arCatalogFilter_248_1240711933","CONTROL_NAME":"arCatalogFilter_248_1240711933","CONTROL_NAME_ALT":"arCatalogFilter_248","HTML_VALUE_ALT":1240711933,"HTML_VALUE":"Y","VALUE":"Ally Paucek","SORT":0,"UPPER":"ALLY PAUCEK","FLAG":true,"URL_ID":"1f17d3cb7c9dfdcc9f60997d5437264a","FACET_VALUE":"6","ELEMENT_COUNT":"1"},"a61cc58109ebced97d4bb2c586d9a99e":{"CONTROL_ID":"arCatalogFilter_248_1962895174","CONTROL_NAME":"arCatalogFilter_248_1962895174","CONTROL_NAME_ALT":"arCatalogFilter_248","HTML_VALUE_ALT":1962895174,"HTML_VALUE":"Y","VALUE":"Bernadine Muller","SORT":0,"UPPER":"BERNADINE MULLER","FLAG":true,"URL_ID":"a61cc58109ebced97d4bb2c586d9a99e","FACET_VALUE":"1","ELEMENT_COUNT":"1"},"b8c1666847a93690a720eebd875e4132":{"CONTROL_ID":"arCatalogFilter_248_2804960024","CONTROL_NAME":"arCatalogFilter_248_2804960024","CONTROL_NAME_ALT":"arCatalogFilter_248","HTML_VALUE_ALT":2804960024,"HTML_VALUE":"Y","VALUE":"Casey Ankunding","SORT":0,"UPPER":"CASEY ANKUNDING","FLAG":true,"URL_ID":"b8c1666847a93690a720eebd875e4132","FACET_VALUE":"3","ELEMENT_COUNT":"1"},"11af6a1cda873afd0ceb0a470054a5fe":{"CONTROL_ID":"arCatalogFilter_248_2429728691","CONTROL_NAME":"arCatalogFilter_248_2429728691","CONTROL_NAME_ALT":"arCatalogFilter_248","HTML_VALUE_ALT":2429728691,"HTML_VALUE":"Y","VALUE":"Dorothy Keeling","SORT":0,"UPPER":"DOROTHY KEELING","FLAG":true,"URL_ID":"11af6a1cda873afd0ceb0a470054a5fe","FACET_VALUE":"2","ELEMENT_COUNT":"1"},"13e8855783dc6f40028023eac8a72e24":{"CONTROL_ID":"arCatalogFilter_248_3889979031","CONTROL_NAME":"arCatalogFilter_248_3889979031","CONTROL_NAME_ALT":"arCatalogFilter_248","HTML_VALUE_ALT":3889979031,"HTML_VALUE":"Y","VALUE":"Gussie Graham","SORT":0,"UPPER":"GUSSIE GRAHAM","FLAG":true,"URL_ID":"13e8855783dc6f40028023eac8a72e24","FACET_VALUE":"4","ELEMENT_COUNT":"1"},"55cae108b137918e8d6fd54129326242":{"CONTROL_ID":"arCatalogFilter_248_2780727159","CONTROL_NAME":"arCatalogFilter_248_2780727159","CONTROL_NAME_ALT":"arCatalogFilter_248","HTML_VALUE_ALT":2780727159,"HTML_VALUE":"Y","VALUE":"Ms. Marge Cruickshank","SORT":0,"UPPER":"MS. MARGE CRUICKSHANK","FLAG":true,"URL_ID":"55cae108b137918e8d6fd54129326242","FACET_VALUE":"5","ELEMENT_COUNT":"1"}}}},"actions":{"resetFilter":{"href":"/blog/filter/clear/apply/","text":"Сбросить фильтр"}}},"catalogSectionList":{"items":[{"id":57791,"name":"Test 2","detailPage":"/blog/test-2/","previewText":"Анонс","detailText":"Подробнее","article":57791,"picture":{"alt":"Test 2","src":"/local/templates/love-you/images/crash_photo.jpeg"},"attributes":{"id":"bx_3966226736_57791"},"date":"10/22/2020 01:38:18 pm","tags":["Ms. Marge Cruickshank (ua)","Gussie Graham (ua)","Ally Paucek (ua)","Casey Ankunding (ua)"]},{"id":57780,"name":"Test","detailPage":"/blog/test/","article":57780,"picture":{"alt":"Test","src":"/upload/resize_cache/iblock/e59/200_200_140cd750bba9870f18aada2478b24840a/e59558d5211e98f8d207d1db814463c2.jpeg"},"attributes":{"id":"bx_3966226736_57780"},"date":"10/21/2020 04:48:37 pm","tags":["Dorothy Keeling (ua)","Bernadine Muller (ua)"]}],"pagination":{"pagingKey":"PAGEN_1","pageCount":1,"pageNumber":1,"pageSize":12},"messages":{"title":"Блог"}}})
            }
        },
        data() {
            return {
                obData: this.result
            }
        },
        methods: {
            /**
             * Тут происходит склеивание данных успешного ответа Ajax запроса
             */
            compareResponse(response){
                const data = response.data.catalogSectionList;

                if (this.debug) {
                    console.log('ajaxResponse', response);
                }

                for (let key in data.items) {
                    this.obData.catalogSectionList.items.push(data.items[key]);
                }

                this.obData.catalogSectionList.pagination = data.pagination;
            },
            /**
             * Имитация перехода на нужную страницу
             */
            replaceResponse(response){
                this.obData = response.data;
            },
            /**
             * Метод по которому происходит Ajax загрузка данных (добавление)
             */
            addMore () {
                if (this.obData.catalogSectionList.pagination.pageCount > this.obData.catalogSectionList.pagination.pageNumber) {
                    axios.get(window.location.href, {
                        params: {
                            api: 'y',
                            [this.obData.catalogSectionList.pagination.pagingKey]: ++this.obData.catalogSectionList.pagination.pageNumber,
                        }
                    })
                        .then(this.compareResponse)
                        .catch(function (error) {
                            console.log(error);
                        })
                        .then(function () {
                            console.log('always executed');
                        });

                }
            },
            /**
             * Метод по которому происходит Ajax переход на нужную страницу
             * @param numb
             */
            getPage(url) {
                axios.get(url, {
                    params: {
                        api: 'y',
                    }
                })
                .then(this.replaceResponse)
                .catch(function (error) {
                    console.log(error);
                });
            },
            createUrl(formData) {
                let url = '?';
                for(let pair of formData.entries()) {
                    if (url[url.length - 1] === '&' || url[url.length - 1] === '?') {
                        url += pair[0]+ '='+ pair[1];
                    } else {
                        url += '&' + pair[0]+ '='+ pair[1];
                    }
                }
                return url;
            },
            changeFilter () {
                try {
                    const formData = new FormData(this.$refs.pageBlogFilter);
                    const url = this.createUrl(formData);

                    fetch(url, {
                        method: this.obData.catalogSmartFilter.form.method,
                    }).then(res => res.json())
                        .then(data => {
                            if (data.SEF_SET_FILTER_URL) {
                                location.pathname = data.SEF_SET_FILTER_URL;
                            } else {
                                console.warn(`data.SEF_SET_FILTER_URL is ${data.SEF_SET_FILTER_URL}`);
                            }

                        })
                } catch (err) {
                    console.error(err);
                }
            }
        },
        mounted() {
            // console.log(this.result)
        }
    }
</script>

<style lang="scss">
    .page-blog-filter{
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        overflow-x: auto;
        padding-left: 15px;
        padding-bottom: 15px;
        @include point-md{
            margin-bottom: 32px;
            padding: 0 15px 15px;
            justify-content: center;
        }
        &__item{
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 8px;
            background: rgba(184, 217, 236, 0.4);
            border-radius: 20px;
            font-weight: 500;
            font-size: rem(12);
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: var(--text-colour-secondary);
            flex-shrink: 0;
            &:not(:last-child) {
                margin-right: 8px;
            }
            &:hover{
                cursor: pointer;
            }
            &_atcive{
                color: #fff;
                background-color: var(--border-colour-primary);
            }
            input{
                display: none;
            }
        }
    }
    .page-blog{
        margin-bottom: 56px;
        margin-top: 16px;
        @include point-md{
            margin-bottom: 80px;
        }
        &__items{
            @include grid(1, 0, 16);
            @include grid-md(2, 24, 24);
            @include grid-lg(3, 40, 40);
        }
        .pagination{
            padding: 40px 0 0;
            @include point-md{
                padding: 56px 0 0;
            }
            @include point-lg{
                padding: 0px;
            }
        }
        .jewelry-card{
            height: auto;
        }
    }
</style>